import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { AppRoute, PetProfileTab } from '@app/components/LocalCommon/const';
import { ApplicationState } from '@app/store';

const AuthWatcher: React.FC = () => {
	const login = useSelector((state: ApplicationState) => state.login, shallowEqual);
	const navigate = useNavigate();

	React.useEffect(() => {
		if (login.user) {
			if (login.user.defaultPetId && login.user.defaultPetId > 0) {
				navigate(`${AppRoute.PET_PROFILE}/${login.user.defaultPetId}/${PetProfileTab.DASHBOARD}`);
			} else {
				navigate(AppRoute.PETS);
			}
		}
	}, [login.user]);

	return null;
};

export default AuthWatcher;
